import React, { Component } from 'react';
import Divider from '@material-ui/core/Divider';
import { Formik } from 'formik';
import {
  SecondaryButton
  , DefaultModuleHeader
  , ButtonSizeOptions
  , SupervisedUserCircle
  , PrimaryButton
  , FormikInputTypeAhead
} from '@loanbossinc/component-library';

import {
  StyledEditRow
  , StyledImageLoader
  , StyledDefaultPerson
  , LABEL_NAMES
} from './peopleBody.helper';

export default class PeopleBodyEdit extends Component {
  formik = React.createRef();

  getFormValues = () => this.formik.current.state.values;

  handleBrokerCompanyChange = (value) => {
    if (!value) this.formik.current.setFieldValue("brokerContactId", null);
    this.props.onBrokerCompanyChange(value);
  }

  getFormState = (values, authInfo) => {
    const isBrokerContactDisabled = !values || !values.brokerCompanyId;
    const brokerData = {
      id: "8d6df618-4a9f-4e16-b010-0acbb92c5e20",
      name: "Broker"
    };

    const isBroker = authInfo?.companyTypes?.find((coTypes) => (coTypes.id === brokerData.id && coTypes.name === brokerData.name));
    return {
      brokerCompany: {
        id: 'brokerCompanyId'
        , name: 'brokerCompanyId'
        , label: LABEL_NAMES.BROKER_COMPANY
        , options: this.props.brokers
        , displayWith: (option) => option && option.name
        , setValueWith: (option) => option && option.id
        , onChange: (value) => this.handleBrokerCompanyChange(value)
      }
      , brokerContact: {
        id: 'brokerContactId'
        , name: 'brokerContactId'
        , label: isBroker ? "Relationship Manager" : LABEL_NAMES.BROKER_CONTACT
        , options: this.props.companyContacts
        , displayWith: (option) => option && option.name
        , setValueWith: (option) => option.id
        , disabled: isBrokerContactDisabled
      }
      , assetManager: {
        id: 'assetManagerId'
        , name: 'assetManagerId'
        , label: LABEL_NAMES.ASSET_MANAGER
        , options: this.props.dealContacts
        , displayWith: (option) => option && option.name
        , setValueWith: (option) => option.id
      }
      , teamMember: {
        id: 'teamMemberId'
        , name: 'teamMemberId'
        , label: LABEL_NAMES.TEAM_MEMBER
        , options: this.props.dealContacts
        , displayWith: (option) => option && option.name
        , setValueWith: (option) => option.id
      }
    };
  }

  renderImage = ({ logoImage }, useImg = false) => {
    if (useImg) return <StyledImageLoader className="rowImage" src={logoImage} defaultImage={process.env.PUBLIC_URL + "/images/default-lender-icon.svg"} />;
    return <StyledDefaultPerson className="rowIcon" />;
  }

  renderBody = ({ handleSubmit, values }) => {
    const { onCancel, authentication } = this.props;
    const formState = this.getFormState(values, authentication);

    return (
      <>
        <DefaultModuleHeader
          headerElement={[<SupervisedUserCircle />]}
          headerTitle="People"
          button={
            <>
              <SecondaryButton
                label={"Cancel"}
                size={ButtonSizeOptions.sm}
                onClick={onCancel}
              />

              <PrimaryButton style={{ marginLeft: '1em' }}
                label={"Save"}
                size={ButtonSizeOptions.sm}
                onClick={handleSubmit}
              />
            </>
          }
        />
        <StyledEditRow>
          <FormikInputTypeAhead {...formState.brokerCompany} className="input" />
          {this.renderImage(formState.brokerCompany, true)}
        </StyledEditRow>
        <Divider />
        <StyledEditRow>
          <FormikInputTypeAhead {...formState.brokerContact} className="input" />
          {this.renderImage(formState.brokerContact)}
        </StyledEditRow>
        <Divider />
        <StyledEditRow>
          <FormikInputTypeAhead {...formState.assetManager} className="input" />
          {this.renderImage(formState.assetManager)}
        </StyledEditRow>
        <Divider />
        <StyledEditRow>
          <FormikInputTypeAhead {...formState.teamMember} className="input" />
          {this.renderImage(formState.teamMember)}
        </StyledEditRow>
      </>
    );
  }

  render() {
    const { initialValues, isVisible } = this.props;
    if (!isVisible) return null;

    return (
      <Formik
        enableReinitialize
        ref={this.formik}
        validateOnChange={true}
        onSubmit={this.props.onSubmit}
        render={this.renderBody}
        initialValues={initialValues}
      />
    );
  }
}
